import { render, staticRenderFns } from "./share_pop.vue?vue&type=template&id=3c6a7af7&"
import script from "./share_pop.vue?vue&type=script&lang=js&"
export * from "./share_pop.vue?vue&type=script&lang=js&"
import style0 from "./share_pop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports